import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Runtime override for the CoreAPI base host. Lets the agent webui talk to a
 * locally-running CoreAPI without rebuilding. Toggle from the chat header
 * (writes localStorage 'coreApi.local') or set manually:
 *   localStorage.setItem('coreApi.local', 'https://localhost:7122/api/')
 *   localStorage.removeItem('coreApi.local')
 */
export const coreApiHostInterceptor: HttpInterceptorFn = (req, next) => {
  let override: string | null = null;
  try { override = localStorage.getItem('coreApi.local'); } catch {}
  if (!override) return next(req);
  const match = req.url.match(
    /^https?:\/\/[^/]*core-api\.ikunnect\.com(?::\d+)?\/api\/(.*)$/
  );
  if (!match) return next(req);
  const base = override.endsWith('/') ? override : override + '/';
  return next(req.clone({ url: base + match[1] }));
};
